import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandX
} from "@tabler/icons-react";

type PlatformIconType = typeof IconBrandFacebook;

export interface PlatformIconMapping {
  facebook: PlatformIconType;
  instagram: PlatformIconType;
  x: PlatformIconType;
  linkedin: PlatformIconType;
}

const platformIcons: PlatformIconMapping = {
  facebook: IconBrandFacebook,
  instagram: IconBrandInstagram,
  x: IconBrandX,
  linkedin: IconBrandLinkedin,
};

export default platformIcons;
